import { useTranslation } from "react-i18next";
import visionImg from "@/assets/vision-3d-camera.png.asset.json";

const VisionBand = () => {
  const { t } = useTranslation();
  return (
    <section data-header-theme="blue" className="relative w-full overflow-hidden bg-black">
      <img
        src={visionImg.url}
        alt={t("sHome.visionBand.alt")}
        className="h-[52vh] md:h-[85vh] w-full object-cover"
        loading="lazy"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-black/40" />

      <div className="absolute inset-0 flex items-start justify-start p-4 sm:p-6 md:p-12">
        <p className="max-w-[14ch] font-serif text-xl sm:text-2xl md:text-4xl lg:text-5xl font-normal leading-[1.12] tracking-[-0.01em] text-white">
          {t("sHome.visionBand.headline")}
        </p>
      </div>

      <div className="absolute inset-x-0 bottom-0 flex justify-end p-4 sm:p-6 md:p-12">
        <p className="max-w-[42ch] text-right text-sm sm:text-base md:text-lg leading-snug text-white/75">
          {t("sHome.visionBand.subtext")}
        </p>
      </div>
    </section>
  );
};

export default VisionBand;
